import { render, staticRenderFns } from "./ClientAuth.vue?vue&type=template&id=4594a217&scoped=true"
import script from "./ClientAuth.vue?vue&type=script&lang=js"
export * from "./ClientAuth.vue?vue&type=script&lang=js"
import style0 from "./ClientAuth.vue?vue&type=style&index=0&id=4594a217&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4594a217",
  null
  
)

export default component.exports